import { render } from "./UiButton.vue?vue&type=template&id=49ff2016&ts=true"
import script from "./UiButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiButton.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49ff2016"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49ff2016', __exports__)) {
    api.reload('49ff2016', __exports__)
  }
  
  module.hot.accept("./UiButton.vue?vue&type=template&id=49ff2016&ts=true", () => {
    api.rerender('49ff2016', render)
  })

}


export default __exports__